<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <PromotionForm
          v-model="promotion"
          :logo-url-base64="logoUrlBase64"
          title="Editace propagace"
          :edit="true"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import PromotionForm from '@/components/forms/PromotionForm'
import arrayBufferToBase64 from '../../../utils/resource'

export default {
  name: 'PromotionEdit',
  components: {
    PromotionForm,
  },
  data() {
    return {
      promotion: {
        logo: null,
      },
      logoBase64: null,
      loading: false,
      saving: false,
    }
  },
  computed: {
    logoUrlBase64() {
      if (this.logoBase64) {
        return `data:image/png;base64,${this.logoBase64}`
      }
      return null
    },
  },
  created() {
    this.loadPromotion()
  },
  methods: {
    ...mapActions({
      getPromotion: 'promotion/getPromotion',
      updatePromotion: 'promotion/updatePromotion',
      getArrayBuffer: 'upload/getArrayBuffer',
    }),
    loadPromotion() {
      this.loading = true
      this.getPromotion(this.$route.params.promotionId)
        .then((response) => {
          this.promotion = response.data
          this.promotion.giftId = response.data.gift.id
          this.loadPromotionLogo(this.promotion.logo.uuid)
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadPromotionLogo(uuid) {
      this.loading = true
      this.getArrayBuffer(uuid)
        .then((response) => {
          this.logoBase64 = arrayBufferToBase64(response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    save(data) {
      this.saving = true
      this.updatePromotion({ promotion: this.promotion, files: data.files })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.back()
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
